export default __webpack_public_path__ + "static/media/FishboneInfographics1.428915f28fe769dc6f6c6ff34b8dbd74.png";